import React, { useState } from "react";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css"; // or import in _index.scss

import {hooks} from '../hooks';
import {SonsType} from '../types';
import {components} from '../components';

export const DetailSonsRkh: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();

  const son: SonsType = location.state.son;
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(today);
  const [opacity, setOpacity] = useState<number>(0);
 

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        title='Child Daily Plan Activities'
      />
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: 10, paddingTop: 8, paddingBottom: 40, gap: 15}}>
          <span onClick={() => navigate(`/detail-sons/detail-sons-absensi/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/absensi-icon-white.png" alt="Absensi Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Absensi</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-rkh/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/rkh-icon-white.png" alt="RKH Icon" />
            <p className='t10' style={{textAlign: 'center'}}>RKH</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-raport/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/raport-icon-white.png" alt="Raport Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Raport</p>
          </span>
      </section>
    );
  };

  const renderImage = (): JSX.Element => {
    return (
      <section style={{position: 'relative'}}>
        <img
          src={son.banner}
          alt={son.name}
          style={{
            width: '100%', 
            borderRadius: 6,
            objectFit: 'cover',
            maxHeight: 260,
            objectPosition: 'top center'
          }}
        />
      </section>
    );
  };

  const renderDaySchedule = (): JSX.Element => {
    const formattedDate = selectedDate
    ? format(selectedDate, "yyyy-MM-dd")
    : null;
    const scheduleForDate = formattedDate
    ? son.study_subjects.find((subject) => subject.date === formattedDate)
    : null;

    return (
      <div style={{ padding: 20 }}>
      {/* Calendar */}
        <DayPicker
          mode="single"
          selected={selectedDate}
          onSelect={setSelectedDate}
        />

      {/* Schedule Card */}
      <section style={{ marginTop: 20 }}>
        {selectedDate && (
          <h3>
            Rencana Kegiatan Harian <br />
            {format(selectedDate, "EEEE, d MMMM yyyy")}
          </h3>
        )}

        {scheduleForDate ? (
          <ul style={{ marginTop: 10 }}>
            {scheduleForDate.data.map((item: any) => (
              <li
                key={item.id}
                style={{
                  padding: 12,
                  marginBottom: 8,
                  background: "#fff",
                  borderRadius: 10,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h4 className='t16'>{item.title}</h4>
                  <p className='t12' style={{ margin: 0, fontSize: 12, color: "#666" }}>
                    {item.time}
                  </p>
                </div>
                <span style={{ color: "green" }}>✔</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className='t12' style={{ marginTop: 10 }}>No activities for this date</p>
        )}
      </section>
    </div>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable container'>
        <ul style={{paddingTop: 10, paddingBottom: 20}}>
          <li
           style={{
            padding: '0 12px',
            borderRadius: 10,
            position: 'relative',
            marginBottom: 15,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 16,
          }}>
            <div
              style={{
                width: '100%',
              }}
            >
              <section style={{minWidth: 140, marginBottom: 15, borderRadius: 6, position: 'relative'}}>
                <div 
                  className='row-center-space-between' 
                  style={{
                    padding: 10, 
                    background: 'linear-gradient(180deg,rgba(255, 255, 255, 0) 50%, rgba(157, 160, 153, 0.4) 75%, rgba(45, 51, 37, 0.8) 100%)',
                    borderRadius: 6, 
                    position: 'absolute',
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                    alignItems: 'flex-end',
                    color: 'var(--main-turquoise)'
                  }}>
                  <h4 style={{color: 'white'}}>{son.name}</h4>
                  <span 
                    onClick={() => navigate(`/detail-sons/detail-sons-grade-analysis/${son.id}`, {state: {son}})} 
                    style={{width:'100%', maxWidth: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, backgroundColor: 'var(--main-turquoise)'}}>
                    <img style={{width: 38, padding: '7px 10px 7px 0'}}  className='clickable' src="/assets/img-icon/chart-white.png" alt="chart Icon"/>
                    <p className='t10' style={{textAlign: 'center', color: 'white', lineHeight: 1.2}}>Grade <br /> Analysis</p>
                  </span>
                </div>
                {renderImage()}
              </section>
              {/* <components.BlockHeading
                title='Child Daily Plan Schedule Activity'
                containerStyle={{marginTop: 20, borderBottom: '1px solid var(--main-turquoise)', paddingBottom: 5}}
              /> */}
              {renderDaySchedule()}
              {renderDetails()}
            </div>
          </li>
        </ul>
      </main>
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
